module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.start = start;
exports.end = end;

var _perf = __webpack_require__(1);

var _measure = __webpack_require__(2);

var START_PREFIX = 'tcc_start_';
var END_PREFIX = 'tcc_end_';

/**
 * @param {String} name
 * @return {Object} Mark
 */
function getMark(name) {
  if (!_perf.globalPerf.getEntriesByName) {
    return null;
  }

  return _perf.globalPerf.getEntriesByName(name, 'mark')[0];
}

/**
 * @param {String} name Mark Name
 * @return {Object} created mark
 */
function createMark(name) {
  if (!_perf.globalPerf.mark) {
    return null;
  }

  _perf.globalPerf.mark(name);
  return getMark(name);
}

/**
 * Creates an start mark for the given metric name
 * @param {String} name
 * @return {Boolean} Has the metric been created?
 */
function start(name) {
  return createMark(START_PREFIX + name);
}

/**
 * Creates and End mark for the given mark name and creates a measure
 * @param {String} name
 * @return {String}
 */
function end(name) {
  var startMark = getMark(START_PREFIX + name);
  var markName = END_PREFIX + name;

  // Only create an end mark if an start mark exists
  if (!startMark) {
    return null;
  }

  createMark(markName);
  (0, _measure.createMeasure)(name, startMark.name, markName);
  return getMark(markName);
}

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var globalPerf = exports.globalPerf = window.performance;
var initialMetrics = exports.initialMetrics = window.__tcc_bm_metrics || {};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMeasure = getMeasure;
exports.createMeasure = createMeasure;
exports.getAllMeasures = getAllMeasures;
exports.resetMeasures = resetMeasures;

var _perf = __webpack_require__(1);

var TCC_MEASURE = 'tcc_measure_';

/**
 * Holds all the custom measure names created
 * @type {Array<String>}
 */
var measureNames = [];

/**
 * Returns a measure by the given name
 * @param {String} name
 * @return {Object} measure
 */
function getMeasure(name) {
  if (!_perf.globalPerf.getEntriesByName) {
    return null;
  }

  return _perf.globalPerf.getEntriesByName(TCC_MEASURE + name)[0];
}

/**
 * Creates a Measure with the given from and to marks
 * @param {String} name
 * @param {String} fromMark
 * @param {String} toMark
 * @return {Object} measure
 */
function createMeasure(name, fromMark, toMark) {
  if (!_perf.globalPerf.measure) {
    return null;
  }

  var tccName = TCC_MEASURE + name;

  // Do not allow overriding
  if (measureNames.includes(tccName)) {
    return false;
  }

  _perf.globalPerf.measure(tccName, fromMark, toMark);
  measureNames = measureNames.concat(name);

  return getMeasure(name);
}

/**
 * Returns a measure by the given name. If no key is passed it returns all the
 * measures.
 * @param {String} [key]
 * @return {Object} Metrics Object
 */
function getAllMeasures() {
  return measureNames.map(getMeasure);
}

/**
 * Needed for testing purposes. Use under your own consideration.
 * @return {void}
 */
function resetMeasures() {
  measureNames = [];
}

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _wrap = __webpack_require__(4);

Object.defineProperty(exports, 'wrapBench', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_wrap).default;
  }
});

var _metric = __webpack_require__(0);

Object.defineProperty(exports, 'start', {
  enumerable: true,
  get: function get() {
    return _metric.start;
  }
});
Object.defineProperty(exports, 'end', {
  enumerable: true,
  get: function get() {
    return _metric.end;
  }
});

var _measure = __webpack_require__(2);

Object.defineProperty(exports, 'getAllMeasures', {
  enumerable: true,
  get: function get() {
    return _measure.getAllMeasures;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = wrap;

var _metric = __webpack_require__(0);

/**
 * Util that Wraps the passed function in between a metric
 * @param {String} name Metric Name
 * @param {Function} func
 * @param {Object} context
 * @return {Function}
 */
function wrap(name, func, context) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    (0, _metric.start)(name);
    var result = func.apply(context, args);

    if (!result || !result.then) {
      (0, _metric.end)(name);
      return result;
    }

    return result.then(function (value) {
      (0, _metric.end)(name);
      return value;
    });
  };
}

/***/ })
/******/ ]);
//# sourceMappingURL=main.js.map